import { connect } from 'react-redux'
import MaintenanceFixComponent from '../components/MaintenanceFixComponent.jsx';
import {
	forwardToFindFixableMCases,
    forwardToAssignModifyingTarget,
    // forwardToFixingMaintenanceCase,
} from '../actions';

const mapStateToProps = (state) => ({

	request: state.getIn(['maintenanceFixingReducer', 'request']),
	response: state.getIn(['maintenanceFixingReducer', 'response']),
	options: state.getIn(['maintenanceFixingReducer', 'options']),

})

const mapDispatchToProps = (dispatch) => ({
	findFixableMCases: () => {
		dispatch(forwardToFindFixableMCases());
	},
	assignModifyingTarget: (mcase) => {
		dispatch(forwardToAssignModifyingTarget(mcase));
	},
    // fixingMaintenanceCase: (mcase) => {
	// 	dispatch(forwardToFixingMaintenanceCase(mcase));
    // }
})

const MaintenanceFixContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(MaintenanceFixComponent)

export default MaintenanceFixContainer;


// WEBPACK FOOTER //
// ./src/containers/MaintenanceFixContainer.jsx